import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedProviderStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface ProviderStatusChangedEventProps {
  event: DiscriminatedProviderStatusChangedEvent;
}

export const ProviderStatusChangedEvent: React.FC<
  ProviderStatusChangedEventProps
> = ({ event }) => {
  const { provider, old_status, new_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-teal-100">
          <ArrowPathIcon className="h-4 w-4 text-teal-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {provider?.name && <ActivityTitle>{provider.name}</ActivityTitle>}
        {old_status && new_status && (
          <ActivityStatusTransition
            from={formatStatus(old_status)}
            to={formatStatus(new_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  const actions = event.payload.target_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/treatment/${event.payload.target_id}`}
      >
        View Provider
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Provider Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
